// extracted by mini-css-extract-plugin
module.exports = {"CardContainerItem":"ConfigurationScreenContentFiltersItem__CardContainerItem__2wI_k","PictureUser":"ConfigurationScreenContentFiltersItem__PictureUser__2zMnM"};